import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPowerPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#FF7A00" rx={5} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.737 9.865h3.69a2.84 2.84 0 0 1 2.836 2.826v.246a3.06 3.06 0 0 1-3.056 3.044h-3.47zM9 7h8.585C20.563 7 23 9.428 23 12.396v.468c0 3.197-2.625 5.813-5.834 5.813H12.7V25H9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPowerPoint;
